module.exports = __webpack_public_path__ + "img/birch-logo-long.bf4753f2.png";